export const BotControl = ({ 
    botStatus, 
    statusLoading, 
    loading, 
    onStart, 
    onStop, 
    onRestart,
    getStatusColor 
}) => {
    const getStatusClass = () => {
        const status = botStatus.toLowerCase();
        if (status.includes('running') || status.includes('active') || status.includes('capturing')) {
            return 'text-green-500';
        }
        if (status.includes('stopped') || status.includes('not running')) {
            return 'text-red-500';
        }
        return 'text-amber-500';
    };

    const getIndicatorClass = () => {
        const status = botStatus.toLowerCase();
        if (status.includes('running') || status.includes('active') || status.includes('capturing')) {
            return 'bg-green-500 shadow-green-500';
        }
        if (status.includes('stopped') || status.includes('not running')) {
            return 'bg-red-500 shadow-red-500';
        }
        return 'bg-amber-500 shadow-amber-500';
    };

    return (
        <div className="bg-slate-800 p-3 rounded-lg border border-slate-700">
            <h2 className="text-sm font-semibold text-white mb-2">
                Bot Control
            </h2>

            <div className="grid grid-cols-2 gap-1.5">
                <button 
                    onClick={onStart}
                    disabled={loading}
                    className={`py-1.5 px-2 text-xs font-medium text-white rounded transition-all ${
                        loading 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-green-500 hover:bg-green-600 cursor-pointer'
                    }`}
                >
                    Start
                </button>

                <button 
                    onClick={onStop}
                    disabled={loading}
                    className={`py-1.5 px-2 text-xs font-medium text-white rounded transition-all ${
                        loading 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-red-500 hover:bg-red-600 cursor-pointer'
                    }`}
                >
                    Stop
                </button>

                <button 
                    onClick={onRestart}
                    disabled={loading}
                    className={`col-span-2 py-1.5 px-2 text-xs font-medium text-white rounded transition-all ${
                        loading 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-blue-500 hover:bg-blue-600 cursor-pointer'
                    }`}
                >
                    Restart
                </button>
            </div>
        </div>
    );
};
